export default __webpack_public_path__ + "static/media/shootingPractice.635a5749.PNG";